import React from "react";
import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Experience from "./components/Experience";
import Attention from "./components/Attention";
import MenuDownload from "./components/MenuDownload";
import Reviews from "./components/Reviews";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import { Toaster } from "./components/ui/sonner";
import { reviews, experiences } from "./data/mock";

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <About />
      <Experience experiences={experiences} />
      <Attention />
      <MenuDownload />
      <Reviews reviews={reviews} />
      <Contact />
      <Footer />
      <WhatsAppButton />
      <Toaster />
    </div>
  );
}

export default App;
